// Utility for Google Analytics (gtag.js)
// Hardcoded GA ID: G-FVEG8GCBXP

const VISITOR_ID_KEY = "ga_visitor_id";

function ensureGtag() {
  if (typeof window === "undefined" || !window.gtag) {
    console.warn("[GA] gtag not available. Make sure the GA script is loaded in index.html");
    return false;
  }
  return true;
}

export function getVisitorId() {
  try {
    let vid = localStorage.getItem(VISITOR_ID_KEY);
    if (!vid) {
      vid = `anon_${Math.random().toString(36).slice(2)}_${Date.now()}`;
      localStorage.setItem(VISITOR_ID_KEY, vid);
    }
    return vid;
  } catch {
    return `anon_${Math.random().toString(36).slice(2)}_${Date.now()}`;
  }
}

export function initGTM(gtmId, userInfo = {}) {
  // No-op: GA is initialized via script in index.html
  // This function is kept for compatibility with GTMTracker component
  if (window._gaInitialized) return;
  
  if (!ensureGtag()) return;

  try {
    const visitorId = getVisitorId();
    
    // Set user properties if available
    // Never send email or name: Google Analytics' terms forbid personal data.
    if (userInfo.userId || userInfo.role) {
      window.gtag('set', 'user_properties', {
        user_id: userInfo.userId || visitorId,
        role: userInfo.role || undefined,
        // Custom dimensions requested by user
        logged_in_user_id: userInfo.userId || undefined,
        org_id: userInfo.orgId || undefined,
        user_role: userInfo.role || undefined,
        login_state: userInfo.userId ? "logged_in" : "anonymous",
        visitor_id: visitorId,
      });
    }

    window._gaInitialized = true;
  } catch (error) {
    console.warn("[GTM] Error initializing GTM:", error);
  }
}

export function trackPageView(path, userInfo = {}) {
  if (!ensureGtag()) return;
  
  try {
    const visitorId = getVisitorId();
    
    // Track page view with custom parameters
    window.gtag('event', 'page_view', {
      page_path: path,
      // No query string: it can carry a patient's phone or name (e.g. ?phone=).
      page_location: window.location.origin + window.location.pathname,
      visitor_id: visitorId,
      user_id: userInfo.userId || visitorId,
      role: userInfo.role || undefined,
      // Custom dimensions
      logged_in_user_id: userInfo.userId || undefined,
      org_id: userInfo.orgId || undefined,
      user_role: userInfo.role || undefined,
      login_state: userInfo.userId ? "logged_in" : "anonymous",
    });
  } catch (error) {
    console.warn("[GTM] Error tracking page view:", error);
  }
}

export function trackUserAction(action, params = {}) {
  if (!ensureGtag()) return;
  
  try {
    window.gtag('event', 'user_action', {
      action,
      ...params,
    });
  } catch (error) {
    console.warn("[GTM] Error tracking user action:", error);
  }
}

export function trackCustomEvent(eventName, params = {}) {
  if (!ensureGtag()) return;

  try {
    window.gtag('event', eventName, {
      ...params,
    });
  } catch (error) {
    console.warn("[GTM] Error tracking custom event:", error);
  }
}

export function trackError(error, errorInfo = {}) {
  if (!ensureGtag()) return;

  try {
    const errorDescription = error?.message || String(error);
    const errorStack = error?.stack || "No stack trace";
    const componentStack = errorInfo?.componentStack || "";

    window.gtag('event', 'exception', {
      description: `${errorDescription} ${componentStack ? `| Component Stack: ${componentStack}` : ''}`,
      fatal: errorInfo.fatal || false,
      error_type: errorInfo.type || "runtime_error",
      error_stack: errorStack,
    });
  } catch (gtmError) {
    console.warn("[GTM] Error tracking exception:", gtmError);
  }
}

